import React from 'react';
import { motion } from 'framer-motion';
import { MascotContainer, Button } from '@/components/site/primitives';
import { fadeUp } from '@/lib/motion';
import { EMPTY_STATE_MESSAGES } from './constants';
import beeBack from '@/assets/bee-back.png';

export default function EmptyState({ type = 'noResults', onCTAClick, size = 'md' }) {
  const message = EMPTY_STATE_MESSAGES[type] ?? EMPTY_STATE_MESSAGES.noResults;
  const compact = size === 'sm';

  return (
    <div className={compact ? 'flex items-center justify-center py-10' : 'flex min-h-[280px] items-center justify-center py-14'}>
      <motion.div variants={fadeUp} initial="hidden" animate="show" className="mx-auto max-w-sm text-center">
        <MascotContainer src={beeBack} alt="" className={compact ? 'mx-auto h-16 w-16' : 'mx-auto h-24 w-24'} />
        <h2 className="mt-4 font-display text-lg font-semibold text-ink">{message.heading}</h2>
        <p className="mt-2 text-sm leading-relaxed text-subtle">{message.subheading}</p>
        {onCTAClick && message.cta && (
          <Button variant="primary" icon={false} onClick={onCTAClick} className="mt-5">
            {message.cta}
          </Button>
        )}
      </motion.div>
    </div>
  );
}
